export type OrderList = OrderSummary[]

export interface OrderSummary {
  id: number
  store_id: number
  name: string
  placement_time: Date
  pickup_time: Date
  accessible_pickup: Date
  status: string
}

export interface OrderProductType {
  price: number
  subtotal: number
  refunded: boolean
  refunded_at: string
  name: string
  selected_attributes: number[]
  variant: string
  special_instructions: string
}

export type OrderProductWithOrderIdType = { id: string } & OrderProductType

interface TransactionType {
  id: number
  order_id: number
  order_product_id: number | null
  amount: number
  created_at: string
  charge_data: {
    brand: string // TODO: put in specific brands
    last_four: string
    wallet: string | null // TODO: put in specific names
  }
  state: 'authorized' | 'captured' | 'void' | 'pending'
  provider: 's' | 'q'
}

interface OrderPromotionType {
  id: number
  name: string
  amount: number
}

interface OrderCreditType {
  id: number
  claimed: number
}

export enum OrderChannel {
  guest = 'guest',
  registered = 'registered',
  appclip = 'appclip',
}

export type OrderType = {
  id: number
  user_id: number
  name: string
  email: string
  pickup_time: string
  placement_time: string
  updated_at: string
  store_id: number
  status: string
  requested_accessible_pickup: boolean
  products: OrderProductType[]
  tax: {
    [key: string]: string
  }
  barista_id: number | null
  barista: string | null
  tip_amount: number
  subtotal: number
  total: number
  transactions: TransactionType[]
  /** @todo remove curbside */
  is_curbside: boolean
  vehicle_description: string | null
  curbside_status: string | null
  eta: string | null
  eta_direction: string | null
  arrived_at: string | null
  checked_out_at: string | null
  last_seen_at: string | null
  promotions: OrderPromotionType[]
  credits: OrderCreditType[]
  customer_name: string | null
  channel: OrderChannel
  is_drive_thru: boolean
}

export type OrderHistoryType = {
  id: number
  cart: {
    updated_at: string
    user: {
      name: string
    }
  }[]
  order: {
    updated_at: string
    user: {
      name: string
    }
  }[]
}
